import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'

export function useOverviewRouteData() {
  const {data, ...rest} = useSuspenseRouteQuery(pullRequestsOverviewRoute, 'mainQuery')
  return {...data, ...rest}
}
